import { styled } from "styled-components";

export const MyInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  width: 290px;
`;
